import { isEmpty, isNil } from 'lodash/lang';
import getTimeString from '@utils/date/get-time-string';
import getAvatar from '@utils/user/get-avatar';
import isSameDate from '@utils/date/is-same-date';
import getDateString from '@utils/date/get-date-string';

/**
 * Handy object to be used on the messages view.
 *
 * @param {Object} messages - { providerUuid, list }
 * @return {Object} The processed object to use
 */
export default function getMessagesData({ providerUuid, list } = {}) {
  if (isEmpty(list) || isNil(providerUuid)) {
    return [];
  }

  return list.map((message, index) => getMessageData(list, { message, index }, providerUuid));
}

/**
 * Gets the message data
 *
 * @param {Array} messages
 * @param {Object} {message, index}
 * @param {String} providerUuid
 * @returns {Object}
 */
function getMessageData(messages, { message, index }, providerUuid) {
  const isSecondary = message.sender.uuid === providerUuid;
  const addDateSeparator = hasDateSeparator(messages, { message, index });

  return {
    message: {
      uuid: message.uuid,
      content: message.message,
      at: getTimeString(message.created_at),
      from: `${message.sender.first_name} ${message.sender.last_name}`,
      avatar: getAvatar(message.sender),
    },
    isSecondary,
    dateLabel: addDateSeparator ? getDateString(message.created_at) : null,
  };
}

/**
 * Verifies if we should display the date separator
 *
 * @param {Array} messages
 * @param {Object} {message, index}
 * @returns {Boolean}
 */
function hasDateSeparator(messages, { message, index }) {
  if (index === 0) {
    return true;
  }

  if (index + 1 > messages.length) {
    return false;
  }

  return !isSameDate(messages[index - 1].created_at, message.created_at);
}
